import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Navbar from '../subcomponents/Navbar'
import Hero from '../subcomponents/Hero'
import SectionTitle from '../subcomponents/SectionTitle';
import ServiceCard from '../subcomponents/ServiceCard';
import SectionDesc from '../subcomponents/SectionDesc';
import Button from '../subcomponents/Button';
import ProductCard from '../subcomponents/ProductCard';
import Footer from '../subcomponents/Footer';

export default function Home() {

    useEffect(() => {
        AOS.init({
            duration: 600,
            offset: 100,
            once: true,
        });
    }, []);


    return (
        <>

            <Navbar />

           <div id='top'>
           <Hero />
           </div>
            <div className='block my-[30px] xm:hidden px-[30px]'>
                <hr className='bg-[#E2CDCD] h-[2px]' />
            </div>
            <div className="p-5" id='our_services'>

                <div className="text-center mt-[30px]">
                    <SectionTitle title="OUR SERVICES" />
                    <SectionDesc desc="We provide great services for our customers based on needs" />

                    <div data-aos="fade-up" className='mt-12 flex flex-wrap justify-center gap-4 relative pb-10'>
                        <ServiceCard image="/images/web_design.svg" name="Designing" description="Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ut aperiam magnam mollitia ipsum quod! Similique consectetur molestias ad perspiciatis neque quisquam! Debitis itaque dolores recusandae doloribus deserunt quia nesciunt cum commodi? Sed,   " bgColor="bg-[#68D585]" />

                        <ServiceCard image="/images/web_development.svg" name="Web Development" description="Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ut aperiam magnam mollitia ipsum quod! Similique consectetur molestias ad perspiciatis neque quisquam! Debitis itaque dolores recusandae doloribus deserunt quia nesciunt cum commodi? Sed, " bgColor="bg-[#473BF0]" />

                        <ServiceCard image="/images/digital_marketing.svg" name="Digital Marketing" description="Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ut aperiam magnam mollitia ipsum quod! Similique consectetur molestias ad perspiciatis neque quisquam! Debitis itaque dolores recusandae doloribus deserunt quia nesciunt cum commodi? Sed,   " bgColor="bg-[#F64B4B]" />

                        <img src={process.env.REACT_APP_PUBLIC_URL + "/images/dotted_rectangle.svg"} className='scale-ani-1 absolute bottom-[-12px] right-4' alt="img" />
                    </div>
                </div>
            </div>

            <div className='block mt-[30px] xm:hidden px-[30px]'>
                <hr className='bg-[#E2CDCD] h-[2px]' />
            </div>

            <div id='why-us' className="py-10 px-5 sm:py-[100px] mt-[30px] sm:bg-[#f4f7fa] relative">
                <img src={process.env.REACT_APP_PUBLIC_URL + "/images/dotted_square.svg"} className='scale-ani-1 absolute hidden md:block left-0 top-20' alt="img" />
                <div className='text-center'>
                    <SectionTitle title="WHY CHOOSE US" />
                    <SectionDesc desc="People choose because we serve the best for everyone" />
                    <div data-aos="fade-up" className='mt-12 sm:max-w-[80%] mx-auto'>
                        <div className=' flex flex-wrap gap-5 justify-center items-center text-start'>
                            <div className='w-full sm:w-[calc(50%-20px)] mb-7 sm:mb-0 flex gap-5 flex-row-reverse sm:flex-row'>
                                <div className="bg-blue-100 p-3 rounded-lg h-fit text-center">
                                    <img src={process.env.REACT_APP_PUBLIC_URL + '/images/person_icon.svg'} className='w-[100px] sm:w-[70px]' alt="icon" />
                                </div>
                                <div>
                                    <h6 className='text-lg sm:text-xl font-bold text-gray-800 mb-1'>Dedicated manager</h6>
                                    <p className='text-gray-500 text-sm sm:text-[16px]'>
                                        With lots of unique blocks, you can easily build a page without coding. Build your next landing page.
                                    </p>
                                </div>
                            </div>
                            <div className='w-full sm:w-[calc(50%-20px)] mb-7 sm:mb-0 flex gap-5'>
                                <div className="bg-red-100 p-3 rounded-lg h-fit">
                                    <img src={process.env.REACT_APP_PUBLIC_URL + '/images/bookmark_icon.svg'} className='w-[100px] sm:w-[70px]' alt="icon" />
                                </div>
                                <div>
                                    <h6 className='text-lg sm:text-xl font-bold text-gray-800 mb-1'>Organized Tasks</h6>
                                    <p className='text-gray-500 text-sm sm:text-[16px]'>
                                        With lots of unique blocks, you can easily build a page without coding. Build your next landing page.
                                    </p>
                                </div>
                            </div>


                        </div>

                        <div className='mt-7 flex flex-wrap gap-5 justify-center items-center text-start'>
                            <div className='w-full sm:w-[calc(50%-20px)] mb-7 sm:mb-0 flex gap-5 flex-row-reverse sm:flex-row'>
                                <div className="bg-green-100 p-3 rounded-lg h-fit">
                                    <img src={process.env.REACT_APP_PUBLIC_URL + '/images/chat_icon.svg'} className='w-[100px] sm:w-[70px]' alt="icon" />
                                </div>
                                <div>
                                    <h6 className='text-lg sm:text-xl font-bold text-gray-800 mb-1'>Easy feedback sharing</h6>
                                    <p className='text-gray-500 text-sm sm:text-[16px]'>
                                        With lots of unique blocks, you can easily build a page without coding. Build your next landing page.
                                    </p>
                                </div>
                            </div>
                            <div className='w-full sm:w-[calc(50%-20px)] mb-7 sm:mb-0 flex gap-5'>
                                <div className="bg-gray-200 p-3 rounded-lg h-fit">
                                    <img src={process.env.REACT_APP_PUBLIC_URL + '/images/deadline_icon.svg'} className='w-[100px] sm:w-[70px]' alt="icon" />
                                </div>
                                <div>
                                    <h6 className='text-lg sm:text-xl font-bold text-gray-800 mb-1'>Never miss deadline</h6>
                                    <p className='text-gray-500 text-sm sm:text-[16px]'>
                                        With lots of unique blocks, you can easily build a page without coding. Build your next landing page.
                                    </p>
                                </div>
                            </div>


                        </div>
                    </div>

                </div>
                <div className='block my-10 w-[90%] max-w-[500px] mx-auto'>
                    <hr className='bg-gray-300 h-[2px]' />
                </div>

                <div className="text-center sm:text-start sm:flex sm:justify-between items-center max-w-[80%] mx-auto">
                    <div className=''>
                        <h2 className='text-xl sm:text-3xl font-semibold max-w-[500px]'>Ready to launch your next project?</h2>
                        <p className='text-gray-600 sm:font-semibold my-3 sm:mt-1 '>Get in touch or book a free consultation to know more.</p>
                    </div>
                    <div className="shrink-0  ">
                        <Button text="Get in touch" />
                    </div>
                </div>

            </div>


            <div id='work_sample' className="relative px-5 my-[30px] text-center">

                <SectionTitle title="OUR PRODUCTS" />
                <SectionDesc desc="People choose because we serve the best for everyone" />

                <div data-aos="fade-up" className="mt-12 flex gap-2 sm:gap-10 sm:max-w-[80%] mx-auto text-start ">

                    <div className='w-[calc(50%-8px)]'>
                        <div className='mb-5'>
                            <ProductCard image={process.env.REACT_APP_PUBLIC_URL + "/images/product2.svg"} category="Graphic Design" name="Aura Design" />
                        </div>

                        <div className='mb-5'>
                            <ProductCard image={process.env.REACT_APP_PUBLIC_URL + "/images/product3.svg"} category="Web Development" name="Gleam Education" />
                        </div>

                    </div>
                    <div className='w-[calc(50%-8px)]'>
                        <div className='mb-5'>
                            <ProductCard image={process.env.REACT_APP_PUBLIC_URL + "/images/product4.svg"} category="Designing" name="Health Care Web" />
                        </div>

                        <div className='mb-5'>
                            <ProductCard image={process.env.REACT_APP_PUBLIC_URL + "/images/product2.svg"} category="Graphic Design" name="Logo Design" />
                        </div>
                    </div>

                </div>
            </div>

            <Footer />



        </>
    )
}
